import React, { useMemo } from 'react';
import { UIGameActionButton } from '../../../common/UIGameActionButton/index.ts';
import { T } from '@colonist/ui';
import { useActionButtonCommonErrors } from '../utils.ts';
import { ActionState, TurnState } from '@colonist/game-states';
import { SHIP_MOVE_IMAGE_PATH } from '../../../utils/gamePieces.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { useCurrentStateValidator } from '../../../store/selectors/useCurrentStateValidator.ts';
import { useMechanicValidatorShipMove } from '../../../store/selectors/useMechanicValidatorShipMove.ts';
export const UIGameActionButtonShipMove = ({ className })=>{
    const myColor = useGameStore((state)=>state.myColor);
    const { sendMoveShip, sendCancelAction, sendClearRoadEdgeHighlight } = useGameStore((state)=>state.gameSendEvent);
    const shipMoveValidator = useMechanicValidatorShipMove();
    const currentState = useGameStore((state)=>state.gameState.currentState);
    const currentStateValidator = useCurrentStateValidator();
    const { errorHelperText, hasCommonErrors } = useActionButtonCommonErrors();
    const isSpecialBuildPhase = currentState.turnState == TurnState.SpecialBuildPhase;
    const actionStatus = useMemo(()=>{
        if (!shipMoveValidator) {
            return {
                canTakeAction: false
            };
        }
        return shipMoveValidator.canPlayerMoveShip(myColor);
    }, [
        shipMoveValidator,
        myColor
    ]);
    const disabled = hasCommonErrors || !actionStatus.canTakeAction || isSpecialBuildPhase;
    const helperText = errorHelperText || actionStatus.errorMessageIfCantTakeAction;
    const actionState = currentStateValidator.getPlayerActionState(myColor);
    const isMovingShip = [
        ActionState.SelectShipToMove,
        ActionState.MoveShip
    ].includes(actionState) && !disabled;
    const icon = SHIP_MOVE_IMAGE_PATH[myColor];
    const onClick = ()=>{
        if (disabled) return;
        if (isMovingShip) {
            sendClearRoadEdgeHighlight();
            sendCancelAction();
        } else {
            sendMoveShip();
        }
    };
    return /*#__PURE__*/ React.createElement(UIGameActionButton, {
        className: className,
        highlight: isMovingShip,
        disabled: disabled,
        helperText: helperText,
        iconPath: icon,
        centerTextTooltip: true,
        tooltipTitle: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.moveShip"
        }),
        onClick: onClick
    });
};
